module.exports = __webpack_public_path__ + "static/media/sac.81e8d64a.jpg";